import { Claim } from './Claim';

export class AuthUserDto {
	userId: number;
	login = '';
	userName = '';
	bearerToken = '';
	contragentId: number;
	isAuthenticated = false;
	expiresInUtc: Date;
	claims: Claim[] = [];
}
